import styled from "styled-components";

export const LiveStreamingTitleIconDefaultBox = styled.div`
    padding: 0 4px;
    margin-right: 1rem;
    border-radius: 2px;
    letter-spacing: 0;

    color: ${({theme}) => theme.colors.bodyBackground.toString()};
    background: ${({theme}) => theme.colors.brandSecondary.toString()};

    animation: FlashingAnimation 2s ease infinite;

    @keyframes FlashingAnimation {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.25;
        }
        100% {
            opacity: 1;
        }
    }
`;
